import { render } from "./DjBatchQueryTab.vue?vue&type=template&id=45158d59&scoped=true"
import script from "./DjBatchQueryTab.vue?vue&type=script&lang=js"
export * from "./DjBatchQueryTab.vue?vue&type=script&lang=js"

import "./DjBatchQueryTab.vue?vue&type=style&index=0&id=45158d59&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45158d59"

export default script